import { CALL } from 'store/actions/types'
import Webphone from 'common/Webphone'
import { store, history } from 'store'
import { setAlert } from './global'
import { DefaultKavkomIntegration } from 'common/Globals'
import { numberValidationError, sipNumberFormat, validateNumber } from 'utils/numberUtils'
import { UrlsProvider } from 'utils/urlUtils'
import { CallPageTypes } from 'common/Enums'
import Api from 'common/Api'

export const callTo = (number) => (dispatch) => {
    if (validateNumber(number)) {
        const sipNumber = sipNumberFormat(number)
        dispatch(changePhoneNumber({ number: sipNumber }))
        dispatch(setupCall({ number: sipNumber }))
        history.push(UrlsProvider.callUrlGenerator(CallPageTypes.Single))
    } else {
        dispatch(validationPhoneError(numberValidationError(number)))
    }
}

export const changePhoneNumber = (payload) => async (dispatch) => {
    if (payload?.number) {
        Webphone.makeCall(sipNumberFormat(payload.number), {
            existingCallId: payload?.existingCallId
        })
    }

    return dispatch({
        type: CALL.CHANGE_PHONE_NUMBER,
        payload
    })
}

export const transfer = (payload) => (dispatch) => {
    Webphone.transferCall(payload.transferingNumber, payload.transferToNumber)

    return dispatch({
        type: CALL.CHANGE_DESTINATION_NUMBER,
        payload
    })
}

export const startCall = (payload) => ({
    type: CALL.START_CALL,
    payload
})

export const endCall = (payload) => (dispatch) => {
    return dispatch({
        type: CALL.END_CALL,
        payload
    })
}

export const changeHold = (payload) => ({
    type: CALL.CHANGE_HOLD,
    payload
})

export const changeMuteMic = (payload) => ({
    type: CALL.CHANGE_MUTE_MIC,
    payload
})

export const changeActive = (payload) => ({
    type: CALL.CHANGE_ACTIVE,
    payload
})

export const changeTimer = (payload) => ({
    type: CALL.CHANGE_TIMER,
    payload
})

export const setupCall = (payload) => ({
    type: CALL.SETUP_CALL,
    payload
})

export const addNewCall = (payload) => (dispatch) => {
    payload?.activeCalls?.length &&
        payload.activeCalls.forEach((number) => {
            if (payload.number !== number) {
                Webphone.setHold(number, true)
            }
        })
    return dispatch({
        type: CALL.ADD_CALL,
        payload
    })
}

export const acceptIncomingCall =
    ({ number }) =>
    (dispatch) => {
        // Hold active call
        const activeCall = store.getState().call.calls.find((item) => item.isActive && !item.isTrying)
        activeCall && Webphone.setHold(activeCall.number, true)
        // Accept new call
        Webphone.acceptCall(number)
    }

export const rejectIncomingCall =
    ({ number }) =>
    (dispatch) => {
        Webphone.rejectCall(number)
    }

export const minimizeIncomingCall = (payload) => ({
    type: CALL.MINIMIZE_CALL,
    payload
})

export const maximizeIncomingCall = (payload) => ({
    type: CALL.MAXIMIZE_CALL,
    payload
})

export const callTransferredHandler = (payload) => (dispatch) => {
    if (payload?.status) {
        dispatch(callTransferSuccess())
        dispatch(setAlert('Call Transferred successfully'))
    } else {
        dispatch(callTransferFail())
        dispatch(setAlert('Call Transfer failed'))
    }
}

export const callTransferSuccess = (payload) => ({
    type: CALL.TRANSFER_SUCCESS,
    payload
})

export const callTransferFail = (payload) => ({
    type: CALL.TRANSFER_FAIL,
    payload
})

export const callTransferClear = (payload) => ({
    type: CALL.TRANSFER_CLEAR,
    payload
})

export const setCallTransfer = (payload) => ({
    type: CALL.SET_TRANSFER,
    payload
})

export const removeCall = (payload) => ({
    type: CALL.REMOVE_CALL,
    payload
})

export const removeCalls = (payload) => ({
    type: CALL.REMOVE_CALLS,
    payload
})

export const validationPhoneError = (payload) => ({
    type: CALL.VALIDATION_ERROR_CALL,
    payload
})

export const clearAlertPhoneError = () => ({
    type: CALL.CLEAR_ALERT
})

export const searchIntegrationNumber = (payload) => {
    return (dispatch) => {
        if (!store.getState().profile?.integration?.find_contact) return

        dispatch({
            type: CALL.SEARCH_INTEGRATION_NUMBER,
            payload
        })

        // Set driver to default CRM key if setting activated
        if (store.getState().settings.searchOnlyKavkomCRM) {
            payload.driver = DefaultKavkomIntegration.key
        }

        return Api.searchIntegrationNumber(payload).then((response) => {
            const { data } = response
            const { number } = payload

            if (data?.success) {
                dispatch(searchIntegrationNumberSuccess({ ...data, number }))
            } else {
                dispatch(searchIntegrationNumberFailed({ number }))
            }
        })
    }
}

export const searchIntegrationNumberSuccess = (payload) => (dispatch) => {
    dispatch({
        type: CALL.SEARCH_INTEGRATION_NUMBER_SUCCESS,
        payload
    })
}

export const searchIntegrationNumberFailed = (payload) => (dispatch) => {
    dispatch({
        type: CALL.SEARCH_INTEGRATION_NUMBER_FAILED,
        payload
    })
}

export const createIntegrationContact = (payload) => (dispatch) => {
    if (!store.getState().profile?.integration?.create_contact) return

    dispatch({
        type: CALL.CREATE_INTEGRATION_CONTACT,
        payload
    })

    return Api.createIntegrationContact(payload).then((response) => {
        const { data } = response

        if (data?.success) {
            dispatch(createIntegrationContactSuccess({ ...data, number: payload.number }))
        } else {
            dispatch(createIntegrationContactFailed(payload))
        }
    })
}

export const createIntegrationContactSuccess = (payload) => (dispatch) => {
    dispatch({
        type: CALL.CREATE_INTEGRATION_CONTACT_SUCCESS,
        payload
    })
}

export const createIntegrationContactFailed = (payload) => (dispatch) => {
    dispatch({
        type: CALL.CREATE_INTEGRATION_CONTACT_FAILED,
        payload
    })
}

export const mergeCalls = (payload) => (dispatch) => {
    dispatch({
        type: CALL.MERGE_CALLS,
        payload
    })
}
